/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { eventCreateReset } from '../../pages/events/createEvent/slice/createEventSlice'
import LocalStorage from "../../hook/LocalStorage";
import HeaderNotifications from "./HeaderNotifications";
import { isTwoWaySmsEnabled } from "../../pages/SmsBilling/smsAccess";

const Header = ({ toggleLayoutHeader, onUnreadConversationCountChange }) => {

  const history = useHistory();

  const { user } = LocalStorage()
  const displayName = (user && (user.company_name || user.first_name)) || 'there';

  const dispatch = useDispatch()

  // Toggle Start
  const [sideToggle, setSideToggle] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(false)
  const toggleAction = () => {
    setSideToggle(!sideToggle);
    toggleLayoutHeader(!sideToggle);
  };
  // Toggle End

  const createEvent = () => {
    dispatch(eventCreateReset())

    history.push('/event/create')
  }

  useEffect(() => {
    if (user) {
      if (user.membership && user.membership.package_type === "trial") {
        setShowUpgrade(true)
      }
      else {
        setShowUpgrade(false)
      }
    }
  }, [user])

  return (
    <>
      <header className="top-header">
        <nav className="navbar navbar-expand d-flex justify-content-between">
          <div className="left-topbar d-flex align-items-center">
            <Link to="#" onClick={toggleAction} className="toggle-btn">
              <i className="bx bx-menu" />
            </Link>

          </div>

          <div className="top-nav-custom-menu right-topbar">
            <div className="header-welcome-copy">
              <strong>Welcome back, {displayName} <span aria-hidden="true">👋</span></strong>
              <small>Here’s what’s happening with your conversations.</small>
            </div>
            {showUpgrade ? (
              <span className="header-upgrade-prompt">
                Upgrade your package
                <Link to="/event/type" className="btn btn-sm btn-outline-primary radius-15">Upgrade</Link>
              </span>
            ) : null}
          </div>

          <div className="right-topbar d-flex align-items-center">

            <ul className="navbar-nav">
              <HeaderNotifications
                enabled={isTwoWaySmsEnabled(user)}
                onUnreadCountChange={onUnreadConversationCountChange}
              />
              <li className="nav-item dropdown dropdown-user-profile">
                <Link to="#" onClick={createEvent} className="header-create-event btn btn-primary radius-10">
                  <i className="bx bx-calendar-plus" /> Create Event
                </Link>
              </li>
            </ul>
          </div>

        </nav>
      </header>
    </>
  );
};

export default Header;
